import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';
import AdminApp from './AdminApp';
import AdminPrint from './AdminPrint';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
// import IRANSans from './Ashksans.ttf';


const THEME = createTheme({
  typography: {
 fontFamily: 'IRANSans',
},
components: {
 MuiCssBaseline: {
   styleOverrides: `
     @font-face {
       font-family: 'IRANSans';
       font-style: normal;
       font-display: swap;
       font-weight: 400;
       src: url('./Ashksans.ttf') format('ttf');
     }
   `,
 },
},
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <ThemeProvider  theme={THEME}>
  <BrowserRouter>
      <Routes>
          <Route path="Rating/:invoiceNo" element={<App />} />
          <Route path="admin/rating/:invoiceNo" element={<AdminApp />} />
          <Route path="admin/print/:invoiceNo" element={<AdminPrint />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider >
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
